import { ComponentPropsWithoutRef, useRef } from 'react';
import { Button } from '@givebutter/primitives/button';
import { useListboxOptionOnKeyUp } from '@givebutter/primitives/combobox';
import { useSearchStore } from 'components/search/useSearchStore';
import { twMerge } from 'tailwind-merge';

interface SearchListItemProps extends Omit<ComponentPropsWithoutRef<'button'>, 'color'> {}

const SearchListItem = (props: SearchListItemProps) => {
    const { searchRef } = useSearchStore();
    const { className = '', children, onKeyUp, onKeyDown, ...rest } = props;
    const ref = useRef<HTMLButtonElement>(null);
    const arrowKeyUpOrDown = useListboxOptionOnKeyUp({ ref, searchRef });

    return (
        <Button
            variant="none"
            ref={ref}
            role={'option'}
            aria-label={'Search result option'}
            aria-selected={'false'}
            onKeyDown={e => {
                arrowKeyUpOrDown(e);
                onKeyDown?.(e);
            }}
            className={twMerge(
                'focus-within::bg-gray-100 group w-full justify-start rounded-md px-1.5 py-1 text-start before:!hidden hover:bg-gray-100 focus:bg-gray-100 active:bg-gray-100',
                className,
            )}
            {...rest}
        >
            {children}
        </Button>
    );
};

export { SearchListItem };
export type { SearchListItemProps };
